<template>
    <div>
        <div style="padding: 0 20px">
            <div class="top">
                <div>
                    <el-select v-model="query.type" size="small" style="width: 120px;margin-right: 20px">
                        <el-option :value="1" label="医生端"></el-option>
                        <el-option :value="0" label="患者端"></el-option>
                    </el-select>
                    
                    <el-button type="primary" @click="search" style="width: 96px;margin-right: 20px">查询</el-button>
                    
                </div>
               
            </div>
            <div>
                <el-table :data="tableData"
                          v-loading="loading"
                          :header-cell-style="{'padding-left': '3%'}"
                          :cell-style="{'padding-left': '3%'}">
                    
                    <el-table-column label="终端">
                        <template slot-scope="scope">
                            <span v-if="scope.row.type === 1">医生端</span>
                            <span v-else>患者端</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="realName" label="反馈人"></el-table-column>
                    <el-table-column prop="phoneNumber" label="联系方式"></el-table-column>
                    <el-table-column prop="message" label="反馈信息"></el-table-column>
                    <el-table-column prop="creationTime" label="时间"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">               
                        
                        <el-button type="text" @click="del(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>                                        
                    
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
    
        </div>
        

    </div>
</template>

<script>    
    export default {
       
        data() {
            return {
                authorization:localStorage.getItem('authorization'),                
                loading: true,
                pageNum: 1,
                pageSize: 10,
                total: 1,
                pages: 1,
                tableData: [],                
                query:{                    
                    type:1,
                },       
            };
        },
        methods: {
            // 获取科室列表
            getData() {
                this.loading = true                
                let params = {
                    type: this.query.type,                                    
                }
                this.axios.post('api-b/10059/100590/'+this.pageNum+"/"+this.pageSize,params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    console.log(res.data)
                    if (res.data.code === 10000) {
                        if (res.data.data.length === 0) {
                            this.$message.info('暂无数据')
                        }
                        this.tableData = res.data.data.list
                        this.total = res.data.data.total
                        
                    } else {
                        this.$message.error(res.data.message)
                        this.tableData = []
                        
                    }
                    this.loading = false
                }).catch(error => {
                    this.tableData = []
                    this.total = 0                     
                    this.loading = false
                })
            },
            // 表格换页
            handlePageChange(val) {
                this.pageNum = val;
                this.getData();
            },
            search(){
                this.getData()       
            },
      
       
            del(data){
                const h = this.$createElement;
                this.$msgbox({
                    message: h('div',{class:'message-box'}, [
                        h('div', { class: 'message-title-box'}, [
                            h('i', { class:'el-icon-warning message-box-icon' }, ''),
                            h('span', { class:'message-box-title'}, '确认要删除该反馈吗？'),
                        ]),
                        
                    ]),
                    showCancelButton: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(() => {                
                    
                    this.axios.get('/api-b/10059/10091/' + data.id,{
                        headers:{
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        if (res.data.code === 10000) {
                            this.$message.success(res.data.message)
                            this.getData()
                        } else {
                            this.$message.error(res.data.message)
                            this.getData()
                        }
                    }).catch(error => {})
                })

            }

           
        },
        watch: {
            
        },
        created() {
            this.getData()                      
        }
    };
</script>

<style>

</style>
<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 12px;
        height: 52px;
    }
    .delete-button {
        margin-left: 20px;
        color: rgba(255,75,75,1) !important;
    }
    .delete-button:hover {
        color: rgba(255,75,75,0.8) !important;
    }
    .delete-button:focus {
        color: rgba(215,37,41,1) !important;
    }
    .dialog-set{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
    }
    .tag-box {
        width: 288px;
        min-height: 30px;
        border-radius: 5px;
        border: 1px solid #DCDFE6;
        padding: 0 15px
    }
    .push {
        color:rgba(238,238,238,1);
        font-size: 32px;
        position: absolute;
        top: 30px;
        left: 30px;
    }
    .course-img {
        position: absolute;
        top: 1px;
        width: 92px;
        height: 92px;
    }
     .upload-input {
        opacity: 0;
        width: 92px;
        height: 92px;
        position: absolute;
        top: 0;
    }
</style>